<template>
  <q-layout view="hHh Lpr lFf">
    <q-layout-header>
      <q-toolbar color="primary">       
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu" />   
        <q-toolbar-title>
          WTracking
           <div slot="subtitle">{{ subTitle }} </div>
        </q-toolbar-title>
        <pwa-install  
          :explainer="$t('global.InstallExplain')" 
          :descriptionheader="$t('global.InstallHeader')"
          :installbuttontext="$t('global.InstallButtonText')"
          :iosinstallinfotext="$t('global.InstallIosInfotext')"
          >
        </pwa-install>
        <!--<img src="@/assets/logo.png" class=" gt-xs logo">-->
        <q-btn flat round dense icon="menu" @click="rightDrawerOpen = !rightDrawerOpen" aria-label="Toggle menu on right side" />
      </q-toolbar>
    </q-layout-header>
    <q-layout-drawer v-model="leftDrawerOpen" :content-class="$q.theme === 'mat' ? 'bg-grey-2' : null">
      <MainMenu></MainMenu>
    </q-layout-drawer>
    <q-page-container>
      <keep-alive> 
        <router-view />
      </keep-alive>  
    </q-page-container>
    
    <q-layout-drawer side="right" v-model="rightDrawerOpen" content-class="bg-grey-3" >
    <keep-alive>
      <component :is=SideDialog v-bind:Parent="Parent" v-bind:GeoRegion="GeoRegion" v-bind:IdWork="IdWork" v-bind:IdUser="IdUser" v-bind:Entity="Entity"></component>
    </keep-alive>
    </q-layout-drawer>
  </q-layout>
</template>

<script>
import { openURL } from 'quasar'
import SideSpace from  './SideSpace'
import SideDialogWelcome from  './SideDialogWelcome'
import SideDialogWork from  './SideDialogWork'
import SideDialogCloseWork from  './SideDialogCloseWork'
import SideDialogEvent from  './SideDialogEvent'
import SideDialogGeoRegionNew from  './SideDialogGeoRegionNew'
import SideDialogGeoRegionEdit from  './SideDialogGeoRegionEdit'
import SideDialogEditWork from  './SideDialogEditWork'
import SideDialogEditEvent from  './SideDialogEditEvent'
import SideDialogDublicateWork from  './SideDialogDublicateWork'
import SideDialogUserNew from './SideDialogUserNew'
import SideDialogPassword from './SideDialogPassword'
import EntityEditor from './EntityEditor'
import SideDialogProduct from './SideDialogProduct'

import MainMenu from './MainMenu'
import {eventBus} from '../main'

export default {
  name: 'LayoutDefault',
  components: {
    SideSpace,
    SideDialogWelcome,
    SideDialogWork,
    SideDialogCloseWork,
    SideDialogEvent,
    SideDialogGeoRegionNew,
    SideDialogGeoRegionEdit,
    SideDialogEditWork,
    SideDialogEditEvent,
    SideDialogDublicateWork,
    SideDialogUserNew,
    SideDialogPassword,
    EntityEditor,
    SideDialogProduct,
    MainMenu
  },
  data () {
    return {
      leftDrawerOpen: this.$q.platform.is.desktop,
      rightDrawerOpen: false,
      SideDialog: 'SideDialogWelcome',
      GeoRegion: null,
      Parent:null,
      IdWork:null,
      IdUser:null,
      Entity: null
    }
  },
  methods: {
    openURL
  },
  created () {
    eventBus.$on('loadDialog', (data) => {
      if(data == 'SideDialogWork' && this.$store.state.session.NeedsClosing == true)
        data = 'SideDialogCloseWork'
      this.SideDialog = data
      this.rightDrawerOpen = true
    }),
    eventBus.$on('loadDialogFinishWork', (data) => {
      this.SideDialog = 'SideDialogCloseWork'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('addGeoRegionDialog', (data) => {
      this.Parent = data
      this.SideDialog = 'SideDialogGeoRegionNew'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('editObject', (data) => {
      this.GeoRegion = data
      this.SideDialog = 'SideDialogGeoRegionEdit'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('editGeoRegion', (data) => {
      this.GeoRegion = data
      this.SideDialog = 'SideDialogGeoRegionEdit'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('editWork', (data) => {
      this.IdWork = data
      this.SideDialog = 'SideDialogEditWork'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('editEvent', (data) => {
      this.Entity = data
      this.SideDialog = 'SideDialogEditEvent'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('dublicateWork', (data) => {
      this.IdWork = data
      this.SideDialog = 'SideDialogDublicateWork'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('Bus_EditUser', (data) => {
      this.IdUser = data
      this.SideDialog = 'SideDialogUserNew'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('closeDialog', () => {
      this.rightDrawerOpen = false
    }),
    eventBus.$on('EntityEdit', (data) => {
      this.Entity = data
      this.SideDialog = 'EntityEditor'
      this.rightDrawerOpen = true
    }),
    eventBus.$on('ProductEdit', (data) => {
      this.Entity = data
      this.SideDialog = 'SideDialogProduct'
      this.rightDrawerOpen = true
    })

  },
  computed: {
    // a computed getter
    subTitle: function () {
      if(!this.$store.state.session)
        return this.$t("global.hello")
       else
         return this.$t("global.hello") + " - " + this.$store.state.session.CustomerName + " - " + this.$store.state.session.FirstName + " " + this.$store.state.session.LastName
    }
  },
  watch: {
    leftDrawerOpen: function (val) {     
      //When we close the left drawer we fire a windows resize even wiht a 250ms delay, this fixes issues wiht the leaflet map.
      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
    },
    rightDrawerOpen: function (val) {
      //When we close the left drawer we fire a windows resize even wiht a 250ms delay, this fixes issues wiht the leaflet map.
      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
    },
  },
}
</script>

<style>
.logo{
  margin-top: 5px;
}
.q-tree-arrow{
  color: blue
}
.q-collapsible-toggle-icon{
  color: blue
}
</style>
